import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./Contact.css";

const primaryContacts = [
  {
    title: "LinkedIn",
    value: "linkedin.com/in/elhacen-elmoustapha-773b401a3",
    href: "https://www.linkedin.com/in/elhacen-elmoustapha-773b401a3/",
    cta: "View LinkedIn profile",
  },
  {
    title: "GitHub",
    value: "github.com/Elhacen18",
    href: "https://github.com/Elhacen18",
    cta: "View GitHub profile",
  },
];

const codingProfiles = [
  {
    title: "LeetCode",
    href: "https://leetcode.com/u/Elhacen/",
  },
  {
    title: "HackerRank",
    href: "https://www.hackerrank.com/profile/elhacen",
  },
];

const newTab = { target: "_blank", rel: "noreferrer" };

class Contact extends Component {
  render() {
    return (
      <div className="Page">
        <div className="PageContainer ContactContainer">
          <h1 className="PageHeading">Contact</h1>
          <p className="PageIntro">
            The best way to reach me is through LinkedIn. You can also find
            my code on GitHub.
          </p>
          <div className="row g-4 justify-content-center">
            {primaryContacts.map((method) => {
              const external = method.href.startsWith("http");
              return (
                <section className="col-md-4" key={method.title}>
                  <div className="Card ContactCard">
                    <h2 className="ContactCardTitle">{method.title}</h2>
                    <p className="ContactValue">{method.value}</p>
                    <a
                      href={method.href}
                      {...(external ? newTab : {})}
                      className="TextLink ContactLink"
                    >
                      {method.cta}
                      <span aria-hidden="true"> &rarr;</span>
                      {external && (
                        <span className="visually-hidden"> (opens in a new tab)</span>
                      )}
                    </a>
                  </div>
                </section>
              );
            })}
          </div>

          <section className="SecondaryContacts" aria-labelledby="coding-profiles">
            <h2 id="coding-profiles" className="SecondaryHeading">
              Coding practice profiles
            </h2>
            <ul className="SecondaryList">
              {codingProfiles.map((profile) => (
                <li key={profile.title}>
                  <a href={profile.href} {...newTab} className="TextLink">
                    {profile.title}
                    <span className="visually-hidden"> (opens in a new tab)</span>
                  </a>
                </li>
              ))}
            </ul>
          </section>
        </div>
      </div>
    );
  }
}

export default Contact;
